import { FundraisingCampaign, FundraisingCampaignJustifyExpenses } from '@/model';
import {
  GetFundraisingCampaignItemResponse,
  GetFundraisingCampaignResponse,
  GetFundraisingCampaignJustifyExpensesResponse,
} from '@/services/response/fundraising-campaign';

export class FundraisingCampaignConverter {
  static toDomainFromGetItemResponse(response: GetFundraisingCampaignItemResponse): FundraisingCampaign {
    return {
      id: response.id,
      created_at: response.created_at,
      title: response.title,
      description: response.description,
      goal: response.goal,
      collected: response.collected,
      status: response.status,
      pix_key: response.pix_key,
      start_at: response.start_at,
      end_at: response.end_at,
      image: response.image,
    };
  }

  static toDomainFromPaginatedResponse(response: GetFundraisingCampaignResponse): FundraisingCampaign[] {
    return response.data.map(FundraisingCampaignConverter.toDomainFromGetItemResponse);
  }

  static toDomainFromGetJustifyExpensesResponse(
    response: GetFundraisingCampaignJustifyExpensesResponse,
  ): FundraisingCampaignJustifyExpenses {
    return {
      id: response.id,
      campaign_name: response.campaign_name,
      collected_value: response.collected_value,
      expenses_details: response.expenses_details,
      total_expenses: response.total_expenses,
      thank_you_message: response.thank_you_message,
    };
  }
}
